import axiosV1 from "@/plugins/axios/configV1";

export default {
    addSerial(serial_no = []) {
        return axiosV1.post(`products/serial-numbers`, { serial_no });
    },
    importSerial(
        file = null,
        per_page = null,
        page = null,
        get_all = null,
        serial_numbers = []
    ) {
        let formData = new FormData();
        formData.append("per_page", per_page);
        formData.append("page", page);
        formData.append("get_all", get_all);
        formData.append("serial_numbers", JSON.stringify(serial_numbers));
        formData.append("file", file);
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return axiosV1.post(`products/serial-numbers/import`, formData);
    },

    paginateSerial(
        per_page = null,
        page = null,
        get_all = null,
        serial_numbers = []
    ) {
        const params = {
            per_page: per_page,
            get_all: get_all,
            page: page,
            data: serial_numbers,
        };

        return axiosV1.post(`products/serial-numbers/paginate`, { ...params });
    },
};
